import { render } from "./Notation.vue?vue&type=template&id=fd4e5de0"
const script = {}

import "./Notation.vue?vue&type=style&index=0&id=fd4e5de0&lang=css"

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__